import {clsx} from "clsx";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "success" | "warning" | "danger" | "info" | "gray";
  size?: "sm" | "md";
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = "gray",
  size = "sm",
  className = "",
}) => {
  const variants = {
    success: "badge-success",
    warning: "badge-warning",
    danger: "badge-danger",
    info: "badge-info",
    gray: "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100",
  };

  const sizes = {
    sm: "badge",
    md: "px-3 py-1 text-sm font-medium rounded-full",
  };

  return (
    <span className={clsx(sizes[size], variants[variant], className)}>
      {children}
    </span>
  );
};

export default Badge;
